import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// ElementUI
import elementUi from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(elementUi)
Vue.config.productionTip = false

//引入全局公共样式
import './assets/css.css';
import './assets/iconfont/iconfont.css';
import './assets/iconfont/iconfont.js';
// 引入axios
import {
  get,
  post
} from './api/http'
Vue.prototype.$get = get
Vue.prototype.$post = post

// 富文本
import VueQuillEditor from 'vue-quill-editor'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

//echarts图表
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.use(VueQuillEditor, /* { default global options } */ )

//公式兼容插件
// import globalVariable from './util/globalVariable'
// Vue.prototype.commonsVariable = globalVariable;
//
import globalVariable from './util/globalVariable'
Vue.prototype.commonsVariable = globalVariable;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
